export default {
    onShareAppMessage () {
        return this.getShareInfo({
            title: `房贷提前还款划算吗？点我立即计算~`,
            path: `/pages/packageA/prepayment_calc/main`,
            imageUrl: 'https://cdn.vip-wifi.com/fangchan/share-img/prepayment_calc.png'
        })
    }
}